<template>
    <v-row>
        <v-col cols="12" lg="auto">
            <v-row class="row--x-small" align="center">
                <v-col>
                    <v-text-field class="w-100" v-model="query.dates[0]" type="date" v-bind="inputAttrs" clearable hide-details outlined />
                    <!-- <v-text-field label="기간(시작)" v-model="query.dates[0]" type="date" v-bind="inputAttrs" clearable /> -->
                </v-col>
                <v-col cols="auto" class="mx-lg-6">~</v-col>
                <v-col>
                    <v-text-field class="w-100" v-model="query.dates[1]" type="date" v-bind="inputAttrs" clearable hide-details outlined />
                    <!-- <v-text-field label="기간(종료)" v-model="query.dates[1]" type="date" v-bind="inputAttrs" clearable /> -->
                </v-col>
            </v-row>
        </v-col>
        <v-spacer class="d-none d-lg-block"></v-spacer>
        <v-col cols="12" lg="auto">
            <v-row justify="end" class="row--x-small">
                <v-col cols="12" lg="auto">
                    <v-select class="w-100 w-lg-140px" v-model="query.searchKey" :items="searchKeys" placeholder="전체" clearable hide-details outlined v-bind="inputAttrs" />
                    <!-- <v-select label="검색유형" v-model="query.searchKey" :items="searchKeys" placeholder="전체" clearable v-bind="inputAttrs" /> -->
                </v-col>
                <v-col cols="9" sm="10" lg="auto">
                    <v-text-field class="w-100 min-w-lg-300px" placeholder="제목을 입력하세요." hide-details outlined v-model="query.searchValue" clearable v-bind="inputAttrs" @keydown.enter="setQuery"></v-text-field>
                    <!-- <v-text-field label="검색어" v-model="query.searchValue" clearable v-bind="inputAttrs" @keydown.enter="setQuery"></v-text-field> -->
                </v-col>
                <v-col cols="3" sm="2" lg="auto">
                    <v-btn class="h-100 w-100 min-w-lg-100px color-white" color="grey-dark" slot="append" @click="setQuery" elevation="0">검색</v-btn>
                    <!-- <v-btn slot="append" text icon class="mt-n3" @click="setQuery"> <v-icon>mdi-magnify</v-icon> </v-btn> -->
                </v-col>
            </v-row>
        </v-col>
    </v-row>
    <!-- <v-row align="center">
        <v-col cols="12" md="4" lg="">
            <v-text-field label="기간(시작)" v-model="query.dates[0]" type="date" v-bind="inputAttrs" clearable />
        </v-col>
        <v-col cols="12" md="4" lg="">
            <v-text-field label="기간(종료)" v-model="query.dates[1]" type="date" v-bind="inputAttrs" clearable />
        </v-col>
        <v-col cols="12" md="4" lg="">
            <v-select label="검색유형" v-model="query.searchKey" :items="searchKeys" placeholder="전체" clearable v-bind="inputAttrs" />
        </v-col>
        <v-col cols="12" md="4" lg="">
            <v-text-field label="검색어" v-model="query.searchValue" clearable v-bind="inputAttrs" @keydown.enter="setQuery">
                <v-btn slot="append" text icon class="mt-n3" @click="setQuery"> <v-icon>mdi-magnify</v-icon> </v-btn>
            </v-text-field>
        </v-col>
    </v-row> -->
</template>

<script>
import { inputAttrs } from "@/assets/variables";

let initQuery = () => ({
    dates: [],
    searchKey: null,
    searchValue: null,
});

let searchKeys = [
    { text: "부품분류", value: "type" },
    { text: "부품명", value: "name" },
    { text: "규격", value: "code" },
    { text: "공급업체", value: "vendor" },
];

export default {
    data: () => ({
        query: initQuery(),

        searchKeys,

        inputAttrs,
    }),
    mounted() {
        this.sync();
    },

    methods: {
        sync() {
            this.query = { ...initQuery(), ...this.$route.query };
        },
        setQuery() {
            let { query: { ...query } = {} } = this;

            let hasStartDate = !!query?.dates?.[0];
            let hasEndDate = !!query?.dates?.[1];
            if (!hasStartDate && hasEndDate) throw new Error("시작 날짜를 설정해주세요");
            if (hasStartDate && !hasEndDate) throw new Error("종료 날짜를 설정해주세요");
            if (!hasStartDate && !hasEndDate) delete query.dates;

            query.page = 1;

            this.$router.push({ query });
        },
    },
};
</script>

<style></style>
